import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, ApplicationConfig, ErrorHandler, importProvidersFrom } from '@angular/core';
import { provideClientHydration, withEventReplay, withHttpTransferCacheOptions } from '@angular/platform-browser';
import {
  provideRouter,
  Router,
  withComponentInputBinding,
  withInMemoryScrolling,
  withViewTransitions
} from '@angular/router';
import { provideSwiperLoader, provideGlobalErrorHandler } from '@usheru-hff/shared/utils';
import { provideScrollRestoration } from '@usheru-hff/ui/router';
import { providePostBootstrapVersionLogger } from '@usheru-hff/shared/utils';

import { NgProgressRouterModule } from 'ngx-progressbar/router';
import { provideLazyToast } from '@usheru-hff/ui/notfication';

import { provideUshTheme } from '@usheru-hff/ui/theme';
import { AppModule } from './app.module';
import { APP_ROUTES } from './app.routes';
import { currentGitVersion } from './version';
import { createErrorHandler, TraceService } from '@sentry/angular';
import { withAllowedViewTransitions } from '@usheru-hff/sdk/route';
import { provideCookiePolicyLink } from '@usheru-hff/sdk/cookies';

export const appConfig: ApplicationConfig = {
  providers: [
    provideSwiperLoader(),
    provideClientHydration(withEventReplay(), withHttpTransferCacheOptions({ includeRequestsWithAuthHeaders: true })),
    provideRouter(
      APP_ROUTES,
      withComponentInputBinding(),
      withInMemoryScrolling({
        scrollPositionRestoration: 'disabled',
        anchorScrolling: 'enabled'
      }),
      withAllowedViewTransitions()
    ),
    provideScrollRestoration(),
    importProvidersFrom(AppModule),
    provideLazyToast(),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    provideGlobalErrorHandler(),
    provideUshTheme(),
    provideCookiePolicyLink(),
    providePostBootstrapVersionLogger(currentGitVersion),
    importProvidersFrom(NgProgressRouterModule),
    provideGlobalErrorHandler(true),
    {
      provide: TraceService,
      deps: [Router]
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [TraceService],
      multi: true
    }
  ]
};
